import { json, postBiz } from '../core/coreapi';
import {
  InvestmentBudgetLine,
  InvestmentBudgetWorkbenchModel,
} from './investmentbudget.models';

import { normalizeWorkbench } from './investmentbudget.normalizers';

const SERVICE = 'investmentbudget';

export async function getInvestmentBudgetWorkbench(
  pci: number
): Promise<InvestmentBudgetWorkbenchModel> {
  const r = await postBiz({ s: SERVICE, a: 'workbench', pci });
  const payload = json(r);
  if (Number(payload?.rc ?? 0) !== 0) {
    throw new Error(payload?.em || 'Unable to load Investment Budget.');
  }
  return normalizeWorkbench(payload);
}

export async function createInvestmentBudget(pci: number, name: string) {
  return json(
    await postBiz({
      s: SERVICE,
      a: 'create',
      pci,
      nam: name || '',
    })
  );
}

export async function saveInvestmentBudgetLines(
  headerid: number,
  stamp: string,
  rows: InvestmentBudgetLine[]
) {
  return json(
    await postBiz({
      s: SERVICE,
      a: 'linesave',
      hid: headerid,
      stp: stamp,
      rcd: rows.filter(
        (r) => r.__dirty || r._state === 'new' || r._state === 'deleted'
      ),
    })
  );
}

export async function validateInvestmentBudget(headerid: number) {
  return json(
    await postBiz({
      s: SERVICE,
      a: 'validate',
      hid: headerid,
    })
  );
}

export async function submitInvestmentBudget(
  headerid: number,
  stamp: string,
  notes: string
) {
  return json(
    await postBiz({
      s: SERVICE,
      a: 'submit',
      hid: headerid,
      stp: stamp,
      nts: notes || '',
    })
  );
}

export async function reopenInvestmentBudget(
  headerid: number,
  stamp: string,
  reason: string
) {
  return json(
    await postBiz({
      s: SERVICE,
      a: 'reopen',
      hid: headerid,
      stp: stamp,
      rsn: reason,
    })
  );
}
